// extracted by mini-css-extract-plugin
export default {"container":"j9utVS","videoEmbed":"x1QQNM","large":"q0le6Y","title":"Gl8eWB","content":"PXvRd6","separator":"HZXMCr","metaContainer":"xrwGqD","text":"H7IWI8"};